import instance from '../../configs/axios';

const getLandingInfo = () => {
  return instance({
    method: 'get',
    url: '/landing',
  });
};

const getCompanies = page => {
  return instance({
    method: 'get',
    url: '/landing/companies',
    params: {
      page: page,
      size: 10,
    },
  });
};

const getJobsByType = (page, type) => {
  return instance({
    method: 'get',
    url: '/landing/job-position',
    params: {
      type,
      page: page,
      size: 10,
    },
  });
};

export { getLandingInfo, getCompanies, getJobsByType };
